export const SOFTLINE_FEATURE_WWS_BASISARTIKELSTAND = 'wwsBasisartikelstand';

export const SOFTLINE_PERMISSION_WWS_BASISARTIKELSTAND = 'BASISARTIKELSTAND';